import { render, staticRenderFns } from "./ApplicantLogin.vue?vue&type=template&id=1594bf51&"
import script from "./ApplicantLogin.vue?vue&type=script&lang=js&"
export * from "./ApplicantLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports